export enum BuyboxReducerActionType {
    PurchaseType = 'purchaseType',
    SeatCount = 'seatCount',
    CookieWarning = 'cookieWarning',
    MixedShoppingCartError = 'mixedShoppingCartError',
    AddToCartError = 'addToCartError',
    AddingMultipleItemsNotAllowedError = 'AddingMultipleItemsNotAllowedError',
    ResetErrors = 'resetErrors',
    ValueVoucherPriceChange = 'valueVoucherPrice',
    ClusterType = 'clusterType',
}
